import React, { Fragment } from 'react';
import Input from '../../../layout/input/Input';
import InputTextArea from '../../../layout/input/InputTextArea';
import Panel from '../../../layout/panel/Panel';

class Link extends React.Component {
    constructor(props) {
        super(props);
}

    render(){
        return(
            <section id="historia">
                <Panel md={12} xs={12} sm={12} lg={12}
                    title={`Link de Ofertas`}
                >
                    <Input
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="link"
                        nome="link"
                        tooltip="Insira o link de Ofertas"                        
                        value={this.props.oferta.link}                                            
                        onChange={e => this.props.onChangeForPropsLinkOferta(e)}
                    >
                    Link:
                    </Input>
                </Panel>

                <Panel md={12} xs={12} sm={12} lg={12}
                    title={`Link da Loja Virtual (AppShop)`}
                >
                    <Input
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="link"
                        nome="link"
                        tooltip="Insira o link da Loja Virtual"                        
                        value={this.props.compre_online.link}                                            
                        onChange={e => this.props.onChangeForPropsLinkCompreOnline(e)}
                    >
                    Link:
                    </Input>
                </Panel>

                <Panel md={12} xs={12} sm={12} lg={12}
                    title={`Informações e Link de Download Google Play`}
                >
                    <InputTextArea
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="texto"
                        nome="texto" 
                        rows = {2}
                        tooltip="Insira o texto que aparecerá na página principal na aba do Google Play"
                        value={this.props.socialGooglePlay.texto} 
                        onChange={e => this.props.onChangeForPropsLinkSocialGooglePlay(e)}                  
                    >
                        Texto:                  
                    </InputTextArea>
                    <Input
                        md={12} 
                        xs={12} 
                        sm={12} 
                        lg={12}
                        id="link"
                        nome="link"
                        tooltip="Insira o link de download do aplicativo no Google Play"                        
                        value={this.props.socialGooglePlay.link}                                            
                        onChange={e => this.props.onChangeForPropsLinkSocialGooglePlay(e)}
                    >
                    Link:
                    </Input>
                </Panel>


            </section>
        )
    }

}

export default Link;